import { render, staticRenderFns } from "./PushSwitch.vue?vue&type=template&id=12cf1aa8"
import script from "./PushSwitch.vue?vue&type=script&lang=js"
export * from "./PushSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports